<template>
  <b-modal 
    v-bind:visible="true"
    size="sm"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    body-class="sedna_loading_modal_body"
  >
    <div class='text-center'>
      <loading-spinner />
      <p class="sedna_loading_modal_title">Just a moment...</p>
    </div>
  </b-modal>
</template>

<script>
import LoadingSpinner from './LoadingSpinner';

export default {
  name: 'loading_modal',
  components: {
    'loading-spinner': LoadingSpinner
  }
}
</script>
